import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useIsAdminOrModerator } from "@circle-react/contexts/punditUserContext";

import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";

import { useIsCircleAIDockNavEnabled } from "./useIsCircleAIDockNavEnabled";

// The admin dock nav is visible while the shell is in admin mode, or whenever
// an admin/moderator is on an admin/settings page — even if the persisted mode
// is "community" (e.g. "Back to community" then a settings URL), so those pages
// always retain their navigation. Admins can also force it open with Circle AI.
export const useIsAdminDockNavVisible = (): boolean => {
  const canUseAdminDock = useIsAdminOrModerator();
  const isDockNavEnabled = useIsCircleAIDockNavEnabled();
  const isAdminArea = useIsAdminArea();
  const mode = useCircleAIShellStore(s => s.mode);
  const isAdminDockForced = useCircleAIShellStore(s => s.isAdminDockForced);

  return (
    isDockNavEnabled &&
    canUseAdminDock &&
    (mode === "admin" || isAdminArea || isAdminDockForced)
  );
};
